import { api, defaultQueriesFor } from '../apiSlice';

export const foodCategoryApi = api
  .enhanceEndpoints({ addTagTypes: ['FoodCategory'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'FoodCategory', 'FoodCategories'),
    }),
  });

export const {
  useCreateFoodCategoryMutation,
  useDeleteFoodCategoryMutation,
  useGetFoodCategoriesQuery,
  useGetFoodCategoryByIdQuery,
  useUpdateFoodCategoryMutation,
} = foodCategoryApi;
